import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiBook, FiChevronLeft, FiChevronRight, FiX, FiEye, FiImage } = FiIcons;

const BookPreviewSection = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Combined array with covers and content pages
  const allImages = [
    {
      title: "ปกหน้าหนังสือ",
      url: "https://static.wixstatic.com/media/4fbfa6_d8ac54a7a1dd459abcc3031a27d29bdf~mv2.png",
      description: "หนังสือ 'แค่หายใจก็เหนื่อย? ลองใช้ชีวิต 24 ซีซั่นดู' - คู่มือเอาชนะ Burnout สำหรับคนยุคใหม่",
      type: "cover",
      color: "#556B2F"
    },
    {
      title: "ปกหลังหนังสือ",
      url: "https://static.wixstatic.com/media/4fbfa6_6e41db8a857a4107be3d65bbbce3e087~mv2.png",
      description: "ข้อมูลสำคัญและสาระสังเขปของหนังสือที่จะช่วยเปลี่ยนชีวิตคุณ",
      type: "cover",
      color: "#E07A5F"
    },
    {
      title: "คำนำ",
      url: "https://static.wixstatic.com/media/4fbfa6_8beb49523aff440bb1abe7f0569b6e06~mv2.png",
      description: "เริ่มต้นเข้าใจปัญหา Burnout ในยุคปัจจุบัน",
      type: "content",
      color: "#6082B6"
    },
    {
      title: "24 ซีซั่นคืออะไร?",
      url: "https://static.wixstatic.com/media/4fbfa6_2869609438dc4b05b4a2deb81a8065c9~mv2.png",
      description: "ทำความรู้จักกับภูมิปัญญาโบราณที่จะเปลี่ยนชีวิตคุณ",
      type: "content",
      color: "#6082B6"
    },
    {
      title: "การใช้ชีวิตตามจังหวะธรรมชาติ",
      url: "https://static.wixstatic.com/media/4fbfa6_f5498bb45ffd47c28a70409ce0824361~mv2.png",
      description: "เรียนรู้วิธีปรับจังหวะชีวิตให้สอดคล้องกับธรรมชาติ",
      type: "content",
      color: "#6082B6"
    },
    {
      title: "เทคนิคการจัดการพลังงาน",
      url: "https://static.wixstatic.com/media/4fbfa6_46e08de004bc47b39219d5b24a52d418~mv2.png",
      description: "วิธีการใช้พลังงานอย่างฉลาดในแต่ละช่วงเวลา",
      type: "content",
      color: "#6082B6"
    },
    {
      title: "การเอาชนะ Burnout",
      url: "https://static.wixstatic.com/media/4fbfa6_2991933b6cd94de8b06c825098f78866~mv2.png",
      description: "กลยุทธ์การฟื้นตัวจากความเหนื่อยล้าอย่างยั่งยืน",
      type: "content",
      color: "#6082B6"
    },
    {
      title: "การปฏิบัติในชีวิตประจำวัน",
      url: "https://static.wixstatic.com/media/4fbfa6_4201e801a6e84c3bbea61dd94a40472d~mv2.png",
      description: "แนวทางปฏิบัติจริงที่นำไปใช้ได้ทันที",
      type: "content",
      color: "#6082B6"
    }
  ];

  const openImageModal = (index) => {
    setSelectedImage(allImages[index]);
    setCurrentImageIndex(index);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  const navigateImage = (direction) => {
    const newIndex = direction === 'next' 
      ? (currentImageIndex + 1) % allImages.length
      : (currentImageIndex - 1 + allImages.length) % allImages.length;
    
    setCurrentImageIndex(newIndex);
    setSelectedImage(allImages[newIndex]);
  };

  return (
    <section className="py-20 px-4 bg-gradient-to-br from-[#F5F5F5] to-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <div className="flex items-center justify-center space-x-3 mb-6">
            <SafeIcon icon={FiBook} className="text-4xl text-[#556B2F]" />
            <h2 className="text-4xl md:text-5xl font-bold text-[#333333]" 
                style={{ fontFamily: 'Kanit, sans-serif' }}>
              ดูตัวอย่างหนังสือ
            </h2>
          </div>
          <p className="text-xl text-[#666666] max-w-3xl mx-auto" 
             style={{ fontFamily: 'Sarabun, serif' }}>
            เปิดดูปกหน้า ปกหลัง และเนื้อหาบางส่วนเพื่อให้คุณรู้ว่าหนังสือเล่มนี้จะช่วยเปลี่ยนชีวิตคุณได้อย่างไร
          </p>
        </motion.div>

        {/* Book Covers Section */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
          className="mb-20"
        >
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-[#333333] mb-4" 
                style={{ fontFamily: 'Kanit, sans-serif' }}>
              ปกหนังสือ
            </h3>
            <p className="text-lg text-[#666666]" 
               style={{ fontFamily: 'Sarabun, serif' }}>
              คลิกเพื่อดูรายละเอียดของปกหน้าและปกหลัง
            </p>
          </div>

          <div className="flex justify-center items-center gap-12 flex-wrap">
            {/* Front Cover */}
            <motion.div
              whileHover={{ y: -10, scale: 1.02 }}
              transition={{ duration: 0.3 }}
              className="relative group cursor-pointer"
              onClick={() => openImageModal(0)}
            >
              <div className="relative">
                <div className="transform rotate-2 group-hover:rotate-0 transition-transform duration-300">
                  <img 
                    src={allImages[0].url}
                    alt="ปกหน้าหนังสือ แค่หายใจก็เหนื่อย?"
                    className="w-56 h-72 object-cover rounded-xl shadow-2xl border-4 border-white"
                  />
                </div>
                
                {/* Hover Overlay */}
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300 rounded-xl flex items-center justify-center">
                  <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-white/90 backdrop-blur-sm rounded-full p-4">
                    <SafeIcon icon={FiEye} className="text-2xl text-[#556B2F]" />
                  </div>
                </div>
                
                {/* Glow Effect */}
                <div className="absolute -inset-1 bg-gradient-to-r from-[#556B2F] to-[#6082B6] rounded-xl blur opacity-0 group-hover:opacity-20 transition-opacity duration-300 -z-10"></div>
              </div>
              
              <div className="text-center mt-6">
                <h4 className="text-xl font-bold text-[#556B2F] mb-2" 
                    style={{ fontFamily: 'Kanit, sans-serif' }}>
                  ปกหน้า
                </h4>
                <p className="text-sm text-[#666666] flex items-center justify-center gap-2">
                  <SafeIcon icon={FiImage} className="text-[#556B2F]" />
                  คลิกเพื่อดูขนาดใหญ่
                </p>
              </div>
            </motion.div>

            {/* Back Cover */}
            <motion.div
              whileHover={{ y: -10, scale: 1.02 }}
              transition={{ duration: 0.3 }}
              className="relative group cursor-pointer"
              onClick={() => openImageModal(1)}
            >
              <div className="relative">
                <div className="transform -rotate-2 group-hover:rotate-0 transition-transform duration-300">
                  <img 
                    src={allImages[1].url}
                    alt="ปกหลังหนังสือ แค่หายใจก็เหนื่อย?"
                    className="w-56 h-72 object-cover rounded-xl shadow-2xl border-4 border-white"
                  />
                </div>
                
                {/* Hover Overlay */}
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300 rounded-xl flex items-center justify-center">
                  <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-white/90 backdrop-blur-sm rounded-full p-4">
                    <SafeIcon icon={FiEye} className="text-2xl text-[#E07A5F]" />
                  </div>
                </div>
                
                {/* Glow Effect */}
                <div className="absolute -inset-1 bg-gradient-to-r from-[#E07A5F] to-[#d16847] rounded-xl blur opacity-0 group-hover:opacity-20 transition-opacity duration-300 -z-10"></div>
              </div>
              
              <div className="text-center mt-6">
                <h4 className="text-xl font-bold text-[#E07A5F] mb-2" 
                    style={{ fontFamily: 'Kanit, sans-serif' }}>
                  ปกหลัง
                </h4>
                <p className="text-sm text-[#666666] flex items-center justify-center gap-2">
                  <SafeIcon icon={FiImage} className="text-[#E07A5F]" />
                  คลิกเพื่อดูขนาดใหญ่
                </p>
              </div>
            </motion.div>
          </div>
        </motion.div>

        {/* Content Preview Section */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
        >
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-[#333333] mb-4" 
                style={{ fontFamily: 'Kanit, sans-serif' }}>
              ตัวอย่างเนื้อหาภายในหนังสือ
            </h3>
            <p className="text-lg text-[#666666]" 
               style={{ fontFamily: 'Sarabun, serif' }}>
              เปิดดูเนื้อหาสำคัญที่จะช่วยเปลี่ยนชีวิตคุณ
            </p>
          </div>

          {/* Content Preview Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {allImages.slice(2).map((image, index) => (
              <motion.div
                key={index + 2}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="group cursor-pointer"
                onClick={() => openImageModal(index + 2)}
              >
                <div className="relative overflow-hidden rounded-2xl bg-white shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105">
                  <div className="relative">
                    <img
                      src={image.url}
                      alt={image.title}
                      className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-110"
                    />
                    
                    {/* Gradient Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    
                    {/* View Icon */}
                    <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <div className="bg-white/90 backdrop-blur-sm rounded-full p-3 transform scale-75 group-hover:scale-100 transition-transform duration-300">
                        <SafeIcon icon={FiEye} className="text-2xl text-[#6082B6]" />
                      </div>
                    </div>
                  </div>
                  
                  <div className="p-6">
                    <h4 className="text-xl font-bold text-[#333333] mb-3 group-hover:text-[#6082B6] transition-colors duration-300"
                        style={{ fontFamily: 'Kanit, sans-serif' }}>
                      {image.title}
                    </h4>
                    <p className="text-[#666666] text-sm leading-relaxed"
                       style={{ fontFamily: 'Sarabun, serif' }}>
                      {image.description}
                    </p>
                    
                    {/* Read More Indicator */}
                    <div className="mt-4 flex items-center text-[#6082B6] text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <SafeIcon icon={FiImage} className="mr-2" />
                      คลิกเพื่อดูรายละเอียด
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Call to Action */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          viewport={{ once: true }}
          className="text-center mt-20"
        >
          <div className="bg-gradient-to-r from-[#F5F5F5] to-white rounded-2xl p-8 shadow-lg">
            <p className="text-lg text-[#666666] mb-6" 
               style={{ fontFamily: 'Sarabun, serif' }}>
              นี่เป็นเพียงตัวอย่างเล็กๆ น้อยๆ เท่านั้น เนื้อหาทั้งหมดรอคุณอยู่ในหนังสือ
            </p>
            <motion.button
              whileHover={{ scale: 1.05, boxShadow: "0 10px 25px rgba(224,122,95,0.3)" }}
              whileTap={{ scale: 0.95 }}
              onClick={() => document.getElementById('offer-section').scrollIntoView({ behavior: 'smooth' })}
              className="bg-[#556B2F] hover:bg-[#4a5929] text-white font-bold py-4 px-8 rounded-full text-lg transition-all duration-300 shadow-lg"
            >
              สั่งซื้อเพื่อดูเนื้อหาครบถ้วน
            </motion.button>
          </div>
        </motion.div>
      </div>

      {/* Enhanced Image Modal */}
      {selectedImage && (
        <div className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50 p-4">
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
            className="relative max-w-5xl max-h-[95vh] overflow-hidden rounded-2xl bg-white shadow-2xl"
          >
            {/* Close Button */}
            <button
              onClick={closeModal}
              className="absolute top-4 right-4 z-10 bg-black/50 hover:bg-black/70 text-white rounded-full p-3 transition-colors duration-300 backdrop-blur-sm"
            >
              <SafeIcon icon={FiX} className="text-2xl" />
            </button>

            {/* Navigation Buttons */}
            <button
              onClick={() => navigateImage('prev')}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 z-10 bg-black/50 hover:bg-black/70 text-white rounded-full p-3 transition-colors duration-300 backdrop-blur-sm"
            >
              <SafeIcon icon={FiChevronLeft} className="text-2xl" />
            </button>
            <button
              onClick={() => navigateImage('next')}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 z-10 bg-black/50 hover:bg-black/70 text-white rounded-full p-3 transition-colors duration-300 backdrop-blur-sm"
            >
              <SafeIcon icon={FiChevronRight} className="text-2xl" />
            </button>

            {/* Image */}
            <div className="flex justify-center bg-gray-100">
              <img
                src={selectedImage.url}
                alt={selectedImage.title}
                className="w-full h-auto max-h-[70vh] object-contain"
              />
            </div>

            {/* Enhanced Image Info */}
            <div className="p-6 bg-white">
              <div className="flex items-start justify-between mb-4">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-3">
                    <div 
                      className="w-4 h-4 rounded-full"
                      style={{ backgroundColor: selectedImage.color }}
                    ></div>
                    <span className="text-sm font-medium text-[#666666] uppercase tracking-wide">
                      {selectedImage.type === 'cover' ? 'ปกหนังสือ' : 'เนื้อหา'}
                    </span>
                  </div>
                  <h3 className="text-2xl font-bold text-[#333333] mb-3"
                      style={{ fontFamily: 'Kanit, sans-serif' }}>
                    {selectedImage.title}
                  </h3>
                  <p className="text-[#666666] leading-relaxed" 
                     style={{ fontFamily: 'Sarabun, serif' }}>
                    {selectedImage.description}
                  </p>
                </div>
              </div>
              
              <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                <div className="text-sm text-[#999999]">
                  ภาพที่ {currentImageIndex + 1} จาก {allImages.length}
                </div>
                <div className="flex items-center gap-2">
                  <div className="flex gap-1">
                    {allImages.map((_, index) => (
                      <button
                        key={index}
                        onClick={() => {
                          setCurrentImageIndex(index);
                          setSelectedImage(allImages[index]);
                        }}
                        className={`w-2 h-2 rounded-full transition-colors duration-200 ${
                          index === currentImageIndex ? 'bg-[#6082B6]' : 'bg-gray-300'
                        }`}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </section>
  );
};

export default BookPreviewSection;